import { Component } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { ForgotPasswordEmailSentComponent } from './forgot-password-email-sent/forgot-password-email-sent.component'
import { Observable } from 'rxjs'
import { FormControlState } from 'ngrx-forms'
import { Store } from '@ngrx/store'
import { selectProfileState } from '../../user-profile.state'

@Component({
  selector: 'cover-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
  styleUrls: ['./forgot-password-dialog.component.scss'],
})
export class ForgotPasswordDialogComponent {
  formState$: Observable<FormControlState<string>>

  constructor(
    private readonly dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<ForgotPasswordDialogComponent>,
    private readonly store: Store,
  ) {
    this.formState$ = store.select(selectProfileState.forgotPasswordControl)
  }

  onSubmit(): void {
    this.dialog.open(ForgotPasswordEmailSentComponent)
    this.dialogRef.close()
  }
}
